import { Button } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import FilterableTableLayout from "../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../modules/filters/filters.types";
import {
  EXCISE_STAMP_INITIAL_FILTERS,
  getExciseStampRequestFilterItems,
  getExciseStampRequestTableColumns,
} from "../../../modules/obligee/exciseStamps/exciseStamps.constants";
import { ExciseStampsContext } from "../../../modules/obligee/exciseStamps/exciseStamps.context";
import { useExciseStampRequestList } from "../../../modules/obligee/exciseStamps/exciseStamps.queries";
import {
  ExciseStampRequest,
  ExciseStampRequestListPayload,
  ExciseStampRequestListResponse,
} from "../../../modules/obligee/exciseStamps/exciseStamps.types";

const ExciseStampRequestList = observer(() => {
  const navigate = useNavigate();
  const { setExciseStamps } = useContext(ExciseStampsContext);

  const handleAddNewExciseStampRequest = () => {
    navigate("/obveznik/akcizneMarkice/noviZahtev");
  };

  const onTableRowClickHandler = (record: ExciseStampRequest) => {
    setExciseStamps({
      selectedMarkicaId: record.id,
      evidencioniBroj: record.brojZahteva,
    });

    navigate(`/obveznik/akcizneMarkice/detaljiMarkica?id=${record.id}`);
  };

  return (
    <FilterableTableLayout<
      ExciseStampRequest,
      ExciseStampRequestListResponse,
      ExciseStampRequestListPayload
    >
      tableName="excise_stamp_request_table"
      dataListKey="exciseStampRequestList"
      toolbarId="excise_stamp_request_list"
      title={t("AKCIZNE_MARKICE.LISTA_AKCIZNIH_MARKICA")}
      getTableColumns={getExciseStampRequestTableColumns}
      queryHook={useExciseStampRequestList}
      filterProps={{
        getFilterItems: getExciseStampRequestFilterItems,
        initialFilters: EXCISE_STAMP_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.EXCISE_STAMP_REQUEST_LIST,
        triggerQueryManually: true,
      }}
      tableRowKey="id"
      onTableRowClick={onTableRowClickHandler}
      toolbarActions={
        <Button type="primary" onClick={handleAddNewExciseStampRequest}>
          {t("AKCIZNE_MARKICE.NOVI_ZAHTEV")}
        </Button>
      }
    />
  );
});

export default ExciseStampRequestList;
